// extracted by mini-css-extract-plugin
export default {"email-sent-header":"sent-files_email-sent-header__k+cLE","sent-files":"sent-files_sent-files__WFT6B","sent-files-link":"sent-files_sent-files-link__2GKqR"};